import { match } from 'ts-pattern';
import type { EagColumn } from '../types/EagColumn';
type RawCell = {
  value: unknown;
  style?: Record<string, unknown>;
  id?: string;
} | null | undefined;
type ImageCellValue = {
  url?: string;
} | null | undefined;
export const getValueFromRawCell = (column: EagColumn, rawCell: unknown): unknown => {
  if (rawCell === null || rawCell === undefined) {
    return rawCell;
  }
  const cell = rawCell as RawCell;
  return match(column.type)
  // FLAG renderer receives the whole raw cell: needs both .value.label and .style.flagColor
  .with('FLAG', () => rawCell)
  // THUMBNAIL: extract the URL string from the nested value object {url: "..."}
  .with('THUMBNAIL', () => {
    const imageValue = cell?.value as ImageCellValue;
    return imageValue?.url ?? null;
  })
  // All other types: extract .value from the wrapper object
  .otherwise(() => cell?.value);
};